import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';

export interface IWizardStepEntityAttributes extends IModelAttributes {
	content: string;
	order: number;
	showForPassengerOnlyBooking: boolean;
	showForVehicleBooking: boolean;
	showForEventBooking: boolean;
	showForFreightBooking: boolean;
	disabled: boolean;
}

@entity('WizardStepEntity', 'Wizard Step')
export default class WizardStepEntity extends Model implements IWizardStepEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute<WizardStepEntity, string>()
	public content: string;

	@observable
	@attribute<WizardStepEntity, boolean>()
	public order: number;

	@observable
	@attribute<WizardStepEntity, boolean>()
	public showForPassengerOnlyBooking: boolean;

	@observable
	@attribute<WizardStepEntity, boolean>()
	public showForVehicleBooking: boolean;

	@observable
	@attribute<WizardStepEntity, boolean>()
	public showForEventBooking: boolean;

	@observable
	@attribute<WizardStepEntity, boolean>()
	public showForFreightBooking: boolean;

	@observable
	@attribute<WizardStepEntity, number>()
	public disabled: boolean;

	constructor(attributes?: Partial<IWizardStepEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IWizardStepEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.content !== undefined) {
				this.content = attributes.content;
			}
			if (attributes.order !== undefined) {
				this.order = attributes.order;
			}
			if (attributes.showForPassengerOnlyBooking !== undefined) {
				this.showForPassengerOnlyBooking = attributes.showForPassengerOnlyBooking;
			}
			if (attributes.showForVehicleBooking !== undefined) {
				this.showForVehicleBooking = attributes.showForVehicleBooking;
			}
			if (attributes.showForEventBooking !== undefined) {
				this.showForEventBooking = attributes.showForEventBooking;
			}
			if (attributes.showForFreightBooking !== undefined) {
				this.showForFreightBooking = attributes.showForFreightBooking;
			}
			if (attributes.disabled !== undefined) {
				this.disabled = attributes.disabled;
			}
		}
	}
}
